/* Text Type — vanilla JS for Shopify Dawn (idempotent + unload-safe) */

(function () {
  const blink = (el, duration) => {
    let visible = true;
    const t = setInterval(() => {
      el.style.opacity = visible ? '0' : '1';
      visible = !visible;
    }, Math.max(100, duration * 1000));
    return () => clearInterval(t);
  };

  const parseBool = (v, d=false) => (v == null ? d : String(v).toLowerCase() === 'true');
  const parseIntOr = (v, d) => (isNaN(parseInt(v, 10)) ? d : parseInt(v, 10));
  const parseFloatOr = (v, d) => (isNaN(parseFloat(v)) ? d : parseFloat(v));

  const decodePhrases = (raw) => {
    if (!raw) return [];
    const text = raw.replace(/&amp;/g, '&')
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&quot;/g, '"')
                    .replace(/&#39;/g, "'");
    return text.split('||').map(s => s.trim()).filter(Boolean);
  };

  const teardown = (root) => {
    // stop timers/blink
    if (root.__textType && root.__textType.stopBlink) root.__textType.stopBlink();
    if (root.__textType && root.__textType.timerId) clearTimeout(root.__textType.timerId);

    // remove previously injected spans (don’t nuke heading content if user added anything else)
    root.querySelectorAll('.text-type__content, .text-type__cursor').forEach(n => n.remove());
    root.__textType = null;
    root.removeAttribute('data-tt-init');
  };

  const initOne = (root) => {
    // If already initialised, clean and re-init to reflect new settings (alignment changes etc.)
    if (root.getAttribute('data-tt-init') === '1') {
      teardown(root);
    }
    root.setAttribute('data-tt-init', '1');

    const phrases = decodePhrases(root.getAttribute('data-phrases'));
    if (!phrases.length) return;

    const typingSpeed   = parseIntOr(root.getAttribute('data-typing-speed'), 50);
    const deletingSpeed = parseIntOr(root.getAttribute('data-deleting-speed'), 30);
    const pauseDuration = parseIntOr(root.getAttribute('data-pause-duration'), 2000);
    const loop          = parseBool(root.getAttribute('data-loop'), true);
    const showCursor    = parseBool(root.getAttribute('data-show-cursor'), true);
    const hideWhileType = parseBool(root.getAttribute('data-hide-cursor-typing'), false);
    const cursorChar    = root.getAttribute('data-cursor-character') || '|';
    const cursorBlink   = parseFloatOr(root.getAttribute('data-cursor-blink'), 0.5);
    const startOnVis    = parseBool(root.getAttribute('data-start-on-visible'), false);
    const reverseMode   = parseBool(root.getAttribute('data-reverse-mode'), false);
    const colorString   = root.getAttribute('data-text-colors') || '';
    const textColors    = colorString.split(',').map(c => c.trim()).filter(Boolean);

    // Create (or re-create) spans
    const contentSpan = document.createElement('span');
    contentSpan.className = 'text-type__content';
    root.appendChild(contentSpan);

    let cursorSpan = null;
    let stopBlink = null;
    if (showCursor) {
      cursorSpan = document.createElement('span');
      cursorSpan.className = 'text-type__cursor';
      cursorSpan.textContent = cursorChar;
      root.appendChild(cursorSpan);
      stopBlink = blink(cursorSpan, cursorBlink);
    }

    let iPhrase = 0, iChar = 0, deleting = false;
    let timerId = null;

    const currentColor = () => (!textColors.length ? null : textColors[iPhrase % textColors.length]);
    const applyColor = () => {
      const clr = currentColor();
      if (clr) contentSpan.style.color = clr;
      else contentSpan.style.removeProperty('color');
    };

    const step = () => {
      const full = reverseMode
        ? phrases[iPhrase].split('').reverse().join('')
        : phrases[iPhrase];

      if (!deleting && iChar < full.length) {
        contentSpan.textContent = full.slice(0, iChar + 1);
        iChar++;
        if (hideWhileType && cursorSpan) cursorSpan.classList.add('text-type__cursor--hidden');
        timerId = setTimeout(step, typingSpeed);
      } else if (!deleting && iChar >= full.length) {
        if (hideWhileType && cursorSpan) cursorSpan.classList.remove('text-type__cursor--hidden');
        timerId = setTimeout(() => {
          if (phrases.length > 1 || loop) {
            deleting = true;
            step();
          }
        }, pauseDuration);
      } else if (deleting && iChar > 0) {
        contentSpan.textContent = full.slice(0, iChar - 1);
        iChar--;
        if (hideWhileType && cursorSpan) cursorSpan.classList.add('text-type__cursor--hidden');
        timerId = setTimeout(step, deletingSpeed);
      } else {
        // finished deleting
        deleting = false;
        if (hideWhileType && cursorSpan) cursorSpan.classList.remove('text-type__cursor--hidden');
        if (iPhrase === phrases.length - 1 && !loop) return;
        iPhrase = (iPhrase + 1) % phrases.length;
        applyColor();
        timerId = setTimeout(step, pauseDuration);
      }
    };

    const start = () => { applyColor(); step(); };

    if (startOnVis) {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            obs.disconnect();
            start();
          }
        });
      }, { threshold: 0.1 });
      obs.observe(root);
      // store for teardown
      root.__textType = { timerId, stopBlink, obs };
    } else {
      start();
      root.__textType = { timerId, stopBlink };
    }
  };

  const initAll = (container) => {
    (container || document).querySelectorAll('.js-text-type').forEach(initOne);
  };


  document.addEventListener('DOMContentLoaded', () => initAll());


  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });


  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.js-text-type').forEach(teardown);
  });

  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target.querySelector('.js-text-type');
    if (el) initOne(el);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const el = e.target.querySelector('.js-text-type');
    if (el) teardown(el);
  });
})();
